import { z } from "zod";
import type { infer as zInfer } from "zod";

export const rakebackBalance = z.object({
  balance: z.number(),
  totalClaimed: z.number(),
  currency: z.string(),
  updatedAt: z.string(),
});

export type RakebackBalance = zInfer<typeof rakebackBalance>;
